<template>
    <select v-model="val">
        <option
            v-for="rate in $store.state.taxRates"
            :value="rate"
        >{{ rate.rate * 100 }}% ({{ rate.name }})</option>
    </select>
</template>

<script>
    export default {
        name: 'TaxRateSelect',
        props: {
            value: {
                type: [Object, Number],
            },
        },
        data() {
            return {
                val: null,
            }
        },
        mounted() {
            this.val = this.parsePropValue()
        },
        methods: {
            parsePropValue() {
                if (typeof this.value === 'object') {
                    return this.value
                }

                if (typeof this.value === 'number') {
                    return this.$store.state.taxRates.find(rate => rate.rate === this.value)
                }

                return this.$store.state.defaultTaxRate
            },
        },
        watch: {
            val(newValue, oldValue) {
                this.$emit('input', newValue)
            },
        }
    }
</script>

